import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import DataCacheService from '@/shared/services/DataCacheService';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  SelectAValue: 'Select a value',
});

class LanguageSelect extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
  };

  static defaultProps = {
    value: undefined,
  };

  state = {
    languages: [],
    selectedValue: undefined,
  };

  componentDidMount() {
    const { value } = this.props;
    const languages = DataCacheService.getDataCache().language;

    this.setState({ languages, selectedValue: value });
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (prevProps.value !== value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ selectedValue: value });
    }
  }

  selectedValueChanged(e) {
    const { onChange } = this.props;
    const { languages } = this.state;
    const selectedOption = languages.find(x => x.code === e.target.value);
    this.setState({ selectedValue: selectedOption.code }, () => onChange(selectedOption.code));
  }

  render() {
    const { languages, selectedValue } = this.state;
    const { intl } = this.props;

    return (
      <select
        onChange={e => this.selectedValueChanged(e)}
        className="form-control"
        value={selectedValue}
      >
        {!selectedValue && selectedValue !== 0 && (
          <option value="">{intl.formatMessage(messages.SelectAValue)}</option>
        )}
        {languages &&
          languages.map(option => (
            <option key={option.code} value={option.code}>
              {option.description}
            </option>
          ))}
      </select>
    );
  }
}

export default injectIntl(LanguageSelect);
